export default __webpack_public_path__ + "static/media/White Logo.863427a4.png";